//
//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ActivityEnum, AlertLevelEnum } from '@shared/Enums'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { dispatchError, OtStoreState } from '@react/redux/store'

import { alertActions } from '@react/redux/alertSlice'
import { ETH_ADDR_ZERO } from '@shared/SchemaTypes'

import { chainActions } from '@react/redux/chainSlice'
import { PerimeterChainAddressesInterface } from '@react/utils/PerimeterAddresses'
import { getChainPerimeterAddressesForChainConfiguration } from '@react/utils/permissionApx'
import { ChainConfiguration } from '@shared/DeploymentConfigs'

export const fetchPerimeterAddressesTx =
  (): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.FECTH_CHAIN_TIMESTAMP_DELTA
    try {
      logOT.debug(activity)

      const { chainConfiguration, isShutdown, stageConfiguration } = getState().chainState
      const { serverApiBaseUrl, restAPIKey, isLyt } = stageConfiguration
      if (isShutdown) {
        logOT.info('fetchPerimeterAddressesTx isShutdown')
        return
      }

      const perimeterAddresses = await fetchPerimeterAddresses(chainConfiguration, serverApiBaseUrl, restAPIKey, isLyt)

      dispatch(chainActions.updatePerimeterAddresses({ perimeterAddresses }))
    } catch (e: any) {
      logOT.error('fetchPerimeterAddressesTx', e)
      dispatch(
        alertActions.addAlert({
          title: 'Could Not Update Perimeter Addresses',
          description: 'Could not Update Perimeter Addresses',
          createdAt: Date.now() / 1000,
          dueDateTime: Date.now() / 1000,
          txHash: '',
          sourceObjectAddr: ETH_ADDR_ZERO,
          alertLevel: AlertLevelEnum.ERROR,
        })
      )
      await dispatchError(dispatch, e, activity, 1027)
    }
  }
export const fetchPerimeterAddresses = async (
  chainConfiguration: ChainConfiguration,
  serverApiBaseUrl: string,
  restAPIKey: string,
  isLyt: boolean
): Promise<PerimeterChainAddressesInterface> => {
  const perimeterAddresses: PerimeterChainAddressesInterface = await getChainPerimeterAddressesForChainConfiguration(
    chainConfiguration,
    serverApiBaseUrl,
    restAPIKey,
    isLyt
  )

  return perimeterAddresses
}
